'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('helpers/utils');

var _QuickSendForwardPopup = require('./QuickSendForwardPopup');

var _QuickSendForwardPopup2 = _interopRequireDefault(_QuickSendForwardPopup);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Loader = require('../Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var QuickSendForwardButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    copyProjectActionData: state.project.copyProjectActionData,
    copyProjectLoading: state.project.copyProjectLoading
  };
}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendForwardButton, _Component);

  function QuickSendForwardButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, QuickSendForwardButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendForwardButton.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardButton)).call.apply(_ref, [this].concat(args)));

    _this.state = { showPopup: false };
    return _this;
  }

  (0, _createClass3.default)(QuickSendForwardButton, [{
    key: 'onForward',
    value: function onForward(data) {
      this.hidePopup();
      _toastr2.default.success('Quick Send forwarded');
      this.props.onForward(data);
    }
  }, {
    key: 'showPopup',
    value: function showPopup(_ref2) {
      var id = _ref2.id;

      this.setState({ showPopup: true, id: id });
    }
  }, {
    key: 'hidePopup',
    value: function hidePopup() {
      this.setState({ showPopup: false });
    }
  }, {
    key: 'forward',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _props, copyProject, id, resp, newId;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _utils.stopEvent)(e);
                _props = this.props, copyProject = _props.copyProject, id = _props.id;
                _context.prev = 2;
                _context.next = 5;
                return copyProject(id).promise;

              case 5:
                resp = _context.sent;
                newId = (0, _get3.default)(resp, 'data.projectId');

                if (newId) {
                  this.showPopup({ id: newId });
                }
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function forward(_x) {
        return _ref3.apply(this, arguments);
      }

      return forward;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          iconClass = _props2.iconClass,
          t = _props2.t,
          copyProjectLoading = _props2.copyProjectLoading,
          copyProjectActionData = _props2.copyProjectActionData,
          data = _props2.data;
      var _state = this.state,
          showPopup = _state.showPopup,
          id = _state.id;

      var isLoading = copyProjectLoading && copyProjectActionData.projectId === this.props.id;
      var isDisabled = isLoading || !data.projectId;

      return _react2.default.createElement(
        _Button2.default,
        {
          className: (0, _classnames2.default)('btn-text', className),
          onClick: this.forward,
          disabled: isDisabled
        },
        isLoading ? _react2.default.createElement(_Loader2.default, { size: 14, className: 'margin-right-5' }) : _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-forward', iconClass) }),
        t('Forward'),
        _react2.default.createElement(_QuickSendForwardPopup2.default, {
          id: id,
          data: data,
          show: showPopup,
          onHide: this.hidePopup,
          onForward: this.onForward
        })
      );
    }
  }]);
  return QuickSendForwardButton;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  copyProject: _propTypes2.default.func,
  copyProjectActionData: _propTypes2.default.object,
  copyProjectLoading: _propTypes2.default.bool,
  data: _propTypes2.default.object,
  iconClass: _propTypes2.default.string,
  id: _propTypes2.default.number,
  onForward: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  copyProjectActionData: {},
  data: {},
  id: 0,
  onForward: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hidePopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hidePopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'forward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'forward'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendForwardButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForwardButton.js
// module id = 835
// module chunks = 1